export default class CreateTagModel {
    organizationId = null;
    name = null;
    color = null;
    group = null;
    description = null;
    icon = null;

    constructor(organizationId, name, color = null, group = null, description = null, icon = null) {
        this.organizationId = organizationId;
        this.name = name;
        this.color = color;
        this.group = group;
        this.description = description;
        this.icon = icon;
    }
}
